import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionB');
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection
                position="hoverL"
                hasAnimation={false}
                pc="https://websiteoss.ecoflow.com/upload/image/1722940829349/a2.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1722940892046/b2.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
            />
        </div>
    );
}
